import React, { useEffect } from 'react'
import { BaseCard } from '@verifier-user/verifier-headless-ui'
import { InfoCDR } from '@verifier-user/verifier-cdr'
import { useApplicationContext } from '../../contexts/appContext'

export const EnergySuccess = () => {
  const { expire } = useApplicationContext()
  useEffect(() => {
    expire()
  }, [])

  return (
    <>
      <h1 className={'text-4xl sm:text-5xl mb-3 leading-tight'}>Thank you!</h1>

      <BaseCard className='mt-0 max-w-screen-md mb-3' data-testid='success-content'>
        <p data-testid='success-content-par-1'>Your energy verification is complete.</p>
        {/*<p data-testid='success-content-par-2'>*/}
        {/*  Please remember to share this email to{' '}*/}
        {/*  <a href={'mailto:contact@greendataexchange.me'}>contact@greendataexchange.me</a> if you wish to share your*/}
        {/*  data and help Verifier in building our home energy ratings model.*/}
        {/*</p>*/}
      </BaseCard>

      <InfoCDR
        accreditationLink={process.env.ACCREDITATION_LINK}
        accreditationNumber={process.env.ACCREDITATION_NUMBER}
        companyName={process.env.COMPANY}
      ></InfoCDR>
    </>
  )
}
